import { Flex } from 'antd';
import type { CSSProperties, ReactNode } from 'react';
import { When } from 'react-if';
import { StyledTag } from '../styled-tag/styled-tag';
import useStatusTag from './status-tag.hook';
import type { Status, StatusTypeEnum } from './status-tag.model';
import { StyledLabel } from './status-tag.style';

interface StatusTagProps {
  tagValue?: ReactNode;
  type?: StatusTypeEnum;
  status: Status;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  alignSelf?: CSSProperties['alignSelf'];
  className?: string;
  tagPadding?: CSSProperties['padding'];
  tagColor?: string;
  positiveStatus?: boolean;
}

const StatusTag = ({
  tagValue,
  type,
  status,
  align,
  justify,
  alignSelf,
  className,
  tagPadding,
  tagColor,
  positiveStatus
}: StatusTagProps) => {
  const { colorStatus, tagContent, label } = useStatusTag(type, status, tagValue, positiveStatus);

  return (
    <Flex gap={8} align={align} justify={justify} data-testid='status-tag' className={className}>
      <StyledTag
        color={colorStatus}
        $alignSelf={alignSelf}
        $bgLight
        $colorStrong
        data-testid={`status-tag-${colorStatus}`}
        tag-padding={tagPadding}
        tag-color={tagColor}>
        {tagContent}
      </StyledTag>
      <When condition={label}>
        <StyledLabel color={colorStatus} $noBg data-testid='status-tag-label'>
          {label}
        </StyledLabel>
      </When>
    </Flex>
  );
};

export default StatusTag;
